import { X } from "lucide-react";
import { useToast, type Toast as ToastType } from "@/hooks/use-toast";
import Button from "./Button";

export function ToastContainer() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onDismiss={() => dismiss(toast.id)}
        />
      ))}
    </div>
  );
}

interface ToastProps {
  toast: ToastType;
  onDismiss: () => void;
}

function Toast({ toast, onDismiss }: ToastProps) {
  const variantStyles = {
    default: "bg-background border-border",
    destructive: "bg-destructive/10 border-destructive/20 text-destructive",
    success: "bg-green-50 border-green-200 text-green-900",
  };

  const baseClasses =
    "flex items-start gap-3 rounded-lg border p-4 shadow-lg animate-in slide-in-from-top-5";
  const variantClass = variantStyles[toast.variant || "default"];
  const classes = `${baseClasses} ${variantClass}`.trim();

  return (
    <div className={classes}>
      <div className="flex-1">
        <p className="font-semibold text-sm">{toast.title}</p>
        {toast.description && (
          <p className="text-sm text-muted-foreground mt-1">
            {toast.description}
          </p>
        )}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onDismiss}
        className="h-6 w-6 p-0"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
